import React from "react";
import { FONTS } from "./inputValues";

export const designTypes = {
  base: "base",
  art: "art",
};

export const qrSettingsInitialState = {
  pattern: "square",
  patternColor: "#000000",
  patternBackground: "#ffffff",
  qrBackgroundColor: "#ffffff",
  patternBackgroundTransparent: false,
  cornetsOuter: null,
  cornetsOuterColor: "#000000",
  cornetsInterior: null,
  cornetsInteriorColor: "#000000",
  logotype: null,
  logotypeSize: 0.3,
  logotypeMargin: 2,
  logotypeBackground: true,
  isSingleColorDots: true,
  isSingleColorExternalEye: true,
  isSingleColorInternalEye: true,
  isSingleColorBackground: null,
  gradientDots: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  gradientExternalEye: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  gradientInternalEye: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  gradientBackground: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  backgroundImage: null,
  backgroundImageSize: 0.8,
};

export const qrFramesInitialState = {
  frame: "noFrame",
  frameColor: "#000000",
  frameTransform: "translate(9, 9)scale(0.95)",
  transformFrameText: "translate(150,295)",
  frameTextColor: "#9c3aaf",
  frameTextToggle: false,
  frameTextFont: FONTS[0],
};

export const qrOptionsInitialState = {
  errorCorrectionLevel: "Q",
};

export const qrTextInitialState = {
  frameText: "",
  draggableText: "",
  fontFamily: "font-family: 'Poppins', sans-serif;",
  fontWeight: 400,
  textSize: -1,
};

export const modalTitleParams = {
  default: "default",
  successTrial: "successTrial",
  startTrial: "startTrial",
};

export const viewModes = {
  generator: "generator",
  landing: "landing",
};

export const DefaultLogoContext = React.createContext("");

export const SIZES = [
  { label: "200x200 px", size: 200 },
  { label: "500x500 px", size: 500 },
  { label: "1000x1000 px", size: 1000 },
  { label: "1500x1500 px", size: 1500 },
  { label: "2000x2000 px", size: 2000 },
];

export const FORMATS = ["png", "svg", "pdf", "eps", "jpg"];

export const LINK_TYPE = {
  link: 1,
  instagram: 19,
  facebook: 20,
  telegram: 21,
  snapchat: 22,
  tiktok: 23,
  twitter: 24,
  youtube: 25,
  video: 29,
  paypal: 30,
  "google-sheet": 31,
  "google-doc": 32,
  "google-form": 33,
  "google-review": 34,
  "with-logo": 35,
  "for-payment": 36,
  spotify: 37,
  "office-365": 38,
  etsy: 39,
  "shape-generator": 40,
  "social-media": 43,
  reddit: 44,
  linkedin: 45,
  calendar: 46,
  venmo: 51,
  amazon: 52,
  attendance: 55,
};

export const vcardTypes = {
  file: "file",
  new: "new",
};
